export default __webpack_public_path__ + "static/media/logo-short.9005d2fb.svg";